import { useEffect } from 'react';
import './style.scss';
import { throttle } from 'lodash';
const holidays = {
    '1-1': '🎆', // 元旦
    '2-14': '❤️', // 情人节
    '6-1': '🚸', // 儿童节
    '8-1': '🪖', // 建军节
    '9-10': '🧑‍🏫', // 教师节
    '10-1': '🎈', // 国庆节
    '12-24': '🎄', // 圣诞节前一天
    '12-25': '🎅' // 圣诞节
};
let monthIcon = {
    1: '❄️',
    2: '❄️',
    3: '🌸',
    4: '🌸',
    5: '🌸',
    6: '🍉',
    7: '🍉',
    8: '🍉',
    9: '🍂',
    10: '🍂',
    11: '🍂',
    12: '❄️'
};

const isHoliday = () => {
    const today = new Date();
    const month = today.getMonth() + 1; // JavaScript 中月份从 0 开始
    const day = today.getDate();
    const todayStr = `${month}-${day}`;
    return holidays[todayStr] || monthIcon[month] || '❄️';
};
const CustomCursor = ({ text }) => {
    let defaultText = isHoliday();
    let cursorText = text || defaultText || '❄️' || '❄';
    console.log(cursorText, 'cursorText');
    const createStar = throttle((e) => {
        let x = e.clientX;
        let y = e.clientY;
        const star = document.createElement('div');
        star.className = 'star';
        star.innerHTML = cursorText;
        // 随机偏移量
        const tx = (Math.random() - 0.5) * 100;
        const ty = (Math.random() - 0.5) * 100;

        star.style.setProperty('--tx', `${tx}px`);
        star.style.setProperty('--ty', `${ty}px`);

        // 随机颜色
        // const colors = ['#ff0', '#0ff', '#f0f', '#0f0'];
        // star.style.background = `radial-gradient(#fff, ${colors[Math.floor(Math.random() * colors.length)]})`;

        star.style.left = x + 'px';
        star.style.top = y + 'px';

        document.body.appendChild(star);

        // 动画结束后移除元素
        setTimeout(() => {
            star.remove();
        }, 1000);
    }, 100);
    useEffect(() => {
        document.addEventListener('mousemove', createStar);
        return () => {
            console.log('removeEventListener');
            document.removeEventListener('mousemove', createStar);
        };
    }, []);
    return <></>;
};

export default CustomCursor;
